import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'beyond-util';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, OnDestroy {
  error: string;
  username: string;
  password: string;
  loginForm: FormGroup;
  private subscriptions = new Array<Subscription>();

  isProd: boolean = environment.production;
  isMaintenance = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private _authSerivice: AuthenticationService
  ) {
    this.loginForm = formBuilder.group({
      uname: [null, [Validators.required, Validators.minLength(3)]],
      upassword: [null, [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit() {
    this._authSerivice.maintenanceModeChecked.subscribe(
      (x: boolean) => (this.isMaintenance = x)
    );
    this._authSerivice.checkMaintenanceMode();
    this.subscriptions.push(
      this._authSerivice.loginError$.subscribe(message => {
        this.error = message;
      })
    );
  }

  login() {
    this.error = null;
    const korisnik = {
      KorisnickoIme: this.username,
      Lozinka: this.password,
    };

    this.subscriptions.push(
      this._authSerivice.login(korisnik).subscribe(() => {
        this.router.navigate(['pages', 'rts']);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts